import { QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from 'next-themes'
import { useState } from 'react'
import { Toaster } from '@/components/nexus/feedback/toaster'
import { TooltipProvider } from '@/components/nexus/feedback/tooltip'
import { ConfirmProvider } from '@/components/nexus/primitives/confirm-dialog'
import { getClientQueryClient } from '@/trpc/client'
import { BrandProvider } from './brand-provider'
import { ConsentBanner } from './consent-banner'
import { PostHogProvider } from './posthog-provider'

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(getClientQueryClient)

  return (
    <BrandProvider>
      <ThemeProvider attribute="class" defaultTheme="light">
        <QueryClientProvider client={queryClient}>
          <PostHogProvider>
            <TooltipProvider delayDuration={200}>
              <ConfirmProvider>{children}</ConfirmProvider>
            </TooltipProvider>
            <Toaster />
            <ConsentBanner />
          </PostHogProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </BrandProvider>
  )
}
